import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOptions = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 8,
			cy: 3,
			r: 1,
			fill: "#F4F4F4"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 8,
			cy: 8,
			r: 1,
			fill: "#F4F4F4"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 8,
			cy: 13,
			r: 1,
			fill: "#F4F4F4"
		})
	]
});
export default SvgOptions;
